$(".c-event-card__toggle-btn").on( "click", function() {
    $(this).closest('.c-event-card').toggleClass("c-event-card--is-open");
});